import { ArticleVO } from '@article/model/vo/article.vo';
import { Connection } from '@3d-scene/model3d/connection';

export class CopyFromOperationState {
    public article: ArticleVO;
    public connections: Connection[];

    constructor(article: ArticleVO, connections: Connection[]) {
        this.article = article;
        this.connections = connections;
    }
}
